import { Logger, type LoggerAPI, LogLevel } from '@ad-lucy/utils';

const logger = Logger({
  tag: 'SERVICES',
  minLevel: LogLevel.DEBUG,
});

export const LoggerService = ((): { getLogger: () => LoggerAPI } => {
  return {
    getLogger: (): LoggerAPI => logger,
  };
})();
